import api from './api';

export const collectionBoyService = {
  /** Master list (Administrator). */
  list: async (params = {}) => {
    const res = await api.get('/collection-boys', { params });
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/collection-boys/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post('/collection-boys', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/collection-boys/${id}`, data);
    return res.data;
  },

  updateStatus: async (id, isActive) => {
    const res = await api.patch(`/collection-boys/${id}/status`, isActive, {
      headers: { 'Content-Type': 'application/json' },
    });
    return res.data;
  },

  /** Active collection boys of the signed-in centre, for the Registration screen. */
  lookup: async () => {
    const res = await api.get('/collection-boys/lookup');
    return res.data;
  },
};

export default collectionBoyService;
